import React from 'react';
import { XIcon, WhatsAppIcon, LinkedInIcon, FacebookIcon, TelegramIcon } from '@/components/ui/SocialIcons';

interface Post {
  title: string;
  excerpt?: string;
}

const buttonBaseStyle = "bg-card text-foreground border-2 border-primary shadow-md font-semibold px-4 py-2 flex items-center gap-2 hover:shadow-xl hover:bg-primary/10 transition-all duration-200 rounded-lg";

export const ShareButtons: React.FC<{ post: Post | null }> = ({ post }) => {
  if (!post) return null;
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const text = encodeURIComponent(`${post.title} - Read on Metefy Blog`);
  const shareUrl = encodeURIComponent(url);

  return (
    <div className="flex gap-4 flex-wrap justify-center">
      {/* X (Twitter) */}
      <a
        href={`https://twitter.com/intent/tweet?text=${text}&url=${shareUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonBaseStyle}
        title="Share on X"
        aria-label="Share on X"
      >
        <XIcon className="w-5 h-5" /> <span>Share on X</span>
      </a>
      {/* WhatsApp */}
      <a
        href={`https://wa.me/?text=${text}%20${shareUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonBaseStyle}
        title="Share on WhatsApp"
        aria-label="Share on WhatsApp"
      >
        <WhatsAppIcon className="w-5 h-5" /> <span>Share on WhatsApp</span>
      </a>
      {/* Telegram */}
      <a
        href={`https://t.me/share/url?url=${shareUrl}&text=${text}`}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonBaseStyle}
        title="Share on Telegram"
        aria-label="Share on Telegram"
      >
        <TelegramIcon className="w-5 h-5" /> <span>Share on Telegram</span>
      </a>
      {/* LinkedIn */}
      <a
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${text}`}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonBaseStyle}
        title="Share on LinkedIn"
        aria-label="Share on LinkedIn"
      >
        <LinkedInIcon className="w-5 h-5" /> <span>Share on LinkedIn</span>
      </a>
      {/* Facebook */}
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonBaseStyle}
        title="Share on Facebook"
        aria-label="Share on Facebook"
      >
        <FacebookIcon className="w-5 h-5" /> <span>Share on Facebook</span>
      </a>
    </div>
  );
};
